import React, {Component} from 'react';
import './Book.css';



export default class Book extends Component {

    constructor(props) {
        super(props);
        this.state = {
            src: '',
            name: props.name,
            desc: props.description,
            author: '',
        }


    }


    componentDidMount() {

        let mydata = {author: ''};

        for (let j = 0; j < this.props.MaterialProperties.length; j++) {
            if (this.props.MaterialProperties[j].pattern === 'COVER_PATH') {
                mydata.src = this.props.MaterialProperties[j].value;
            }


            if (this.props.MaterialProperties[j].pattern === 'AUTHOR') {
                if (mydata.author != '') {
                    mydata.author += ' , '
                }
                mydata.author += this.props.MaterialProperties[j].value;
            }

        }

        this.setState(mydata);

    }


    createMarkup() {
        return {__html: this.state.desc.substr(0, 750) + "..."}
    }


    // onclick(){
    //     this.props.callbackFromParent(this);
    // }


    render() {

        if (this.props.typee === 1) {

            return (

                <div className="sliderBook">

                    <a href={"#bookdetail" + this.props.id}>
                        <img width={166} height={276}  onError={(e) => {
                            e.target.src = "assets/book.png"
                        }}
                             src={this.state.src}/>
                        <br/>
                        <h6>
                            {"("+this.props.material_type+")"}
                        </h6>
                        <h6>
                            {this.state.name}
                        </h6>
                        {/*<h6>{this.state.author}</h6>*/}
                    </a>
                </div>


            )


        } else {

            return (

                <div style={{clear: 'both'}} className="Book">
                    <a href={"#bookdetail" + this.props.id}>

                        <p style={{float: 'left', margin: '20px 30px 30px'}}><img width={166}
                                                                                  onError={(e) => {
                                                                                      e.target.src = "assets/book.png"
                                                                                  }}
                                                                                  src={this.state.src}/>
                        </p>
                        <br/>

                        <h2>{this.props.name}</h2>
                        <h6>
                            {"Türü : "+this.props.material_type}
                        </h6>
                        <h6>{this.state.author} </h6>
                        <br/>
                        <div dangerouslySetInnerHTML={this.createMarkup()}/>
                    </a>
                    <br/>
                </div>


            )


        }


    }

}


// WEBPACK FOOTER //
// ./src/components/Book.js